export const CANONICAL_HOST_BY_FIREBASE_HOST: Readonly<Record<string, string>> = {
  'vision-lab-frontend-dev.firebaseapp.com': 'dev.thevisionlab.ai',
  'vision-lab-frontend-dev.web.app': 'dev.thevisionlab.ai',
  'vision-lab-frontend.firebaseapp.com': 'app.thevisionlab.ai',
  'vision-lab-frontend.web.app': 'app.thevisionlab.ai',
};
